var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1101 11.7151C11.0459 11.7059 10.9634 11.7059 10.8901 11.7151C9.27674 11.6601 7.99341 10.3401 7.99341 8.7176C7.99341 7.05844 9.33174 5.71094 11.0001 5.71094C12.6592 5.71094 14.0067 7.05844 14.0067 8.7176C13.9976 10.3401 12.7234 11.6601 11.1101 11.7151Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1784 17.7647C15.5468 19.2589 13.3834 20.1664 11.0001 20.1664C8.61678 20.1664 6.45344 19.2589 4.82178 17.7647C4.91344 16.903 5.46344 16.0597 6.44428 15.3997C8.95594 13.7314 13.0626 13.7314 15.5559 15.3997C16.5368 16.0597 17.0868 16.903 17.1784 17.7647Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 20.1663C16.0625 20.1663 20.1666 16.0623 20.1666 10.9997C20.1666 5.93706 16.0625 1.83301 10.9999 1.83301C5.93731 1.83301 1.83325 5.93706 1.83325 10.9997C1.83325 16.0623 5.93731 20.1663 10.9999 20.1663Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.2b5478b66627d59b7c718a220784136c.svg";
export { ForwardRef as ReactComponent };